import React, { useMemo, useState } from 'react';
import { VirtualList } from '@epam/promo';
import { VirtualListState } from '@epam/uui-core';
import { useTaskGroupsStore } from 'store/task-groups';
import { DragableGroupsItem, TaskGroupsItem } from '../TaskGroupsItem';
import { GroupsProps } from './TaskGroupsList.model';

export const TaskGroupsList = ({ groups }: GroupsProps) => {
  const { isControlsShown } = useTaskGroupsStore((state) => state);
  const [state, setState] = useState<VirtualListState>({
    topIndex: 0,
    visibleCount: 10,
  });

  const visibleRows = useMemo(
    () => groups.map((item) => <TaskGroupsItem key={item.id} item={item} />),
    [groups],
  );

  return isControlsShown ? (
    <DragableGroupsItem groups={groups} />
  ) : (
    <VirtualList
      role="listbox"
      rows={visibleRows}
      rowsCount={groups?.length}
      value={state}
      onValueChange={setState}
    />
  );
};
